import { addDays } from "date-fns/addDays";
import { differenceInCalendarDays } from "date-fns/differenceInCalendarDays";
import { format } from "date-fns/format";
import { isBefore } from "date-fns/isBefore";
function getFormattedDates({ dates, dateFormat, displayNights }) {
    if (!dates) return '';
    if ('from' in dates) {
        const range = dates;
        const fromDate = range.from ? format(range.from, dateFormat) : '';
        const toDate = range.to ? format(range.to, dateFormat) : '';
        let formattedDates = '';
        if (fromDate) if (displayNights && toDate) {
            const diffInDays = differenceInCalendarDays(toDate, fromDate);
            formattedDates = `${fromDate} - ${toDate} (${diffInDays} nights)`;
        } else formattedDates = `${fromDate} - ${toDate}`;
        return formattedDates;
    }
    if (Array.isArray(dates)) return dates.map((date)=>format(date, dateFormat)).join(', ');
    return format(dates, dateFormat);
}
function shouldAutoClose(mode, newDates) {
    return 'single' === mode || 'range' === mode && 'object' == typeof newDates && null !== newDates && 'from' in newDates && 'to' in newDates && null != newDates.from && null != newDates.to || 'multiple' === mode && Array.isArray(newDates) && newDates.length >= 2;
}
function isDateRange(value) {
    return void 0 !== value && 'object' == typeof value && null !== value && 'from' in value && 'to' in value;
}
function getHoveredDateRange({ mode, selectedDates, hoveredDate }) {
    if (!hoveredDate) return;
    if ('range' === mode && selectedDates && isDateRange(selectedDates) && selectedDates.from && !selectedDates.to) {
        const displayHoveredRange = hoveredDate && !isBefore(hoveredDate, selectedDates.from) && differenceInCalendarDays(hoveredDate, selectedDates.from) > 1;
        return {
            hoveredRangeStart: [
                selectedDates.from
            ],
            hoveredRange: displayHoveredRange ? {
                from: addDays(selectedDates.from, 1),
                to: addDays(hoveredDate, -1)
            } : void 0,
            hoveredRangeEnd: [
                hoveredDate
            ]
        };
    }
}
function resetDates({ triggerDate, datesResetRef, selectedDates }) {
    if (!datesResetRef.current) {
        datesResetRef.current = true;
        return {
            from: triggerDate,
            to: void 0
        };
    }
    if (selectedDates && isDateRange(selectedDates) && selectedDates.from && isBefore(triggerDate, selectedDates.from)) return {
        from: triggerDate,
        to: void 0
    };
}
function getDefaultMonth({ mode, selected }) {
    if (!selected) return;
    if ('range' === mode) return selected.from;
    if ('multiple' === mode) return selected[0];
    return selected;
}
export { getDefaultMonth, getFormattedDates, getHoveredDateRange, isDateRange, resetDates, shouldAutoClose };
